/**
 * Get the properties (of a geojson feature properties) that are either
 * in the includes list or not in the excludes lists.
 */

import get from 'lodash/get'
import isNil from 'lodash/isNil'
import isObject from 'lodash/isObject'

export default function (layer, properties) {
  if (isNil(layer) || isNil(properties) || !isObject(properties)) {
    console.log('GetDisplayProperties - Invalid layer or properties object!')
    return {}
  }

  const visibleProps = {}
  const visiblePropsArray = []
  const layerIncludes = get(layer, 'config.spatial.include', [])
  const layerIncludesLower = layerIncludes.map(item => item.toLowerCase())

  // Check if any provided layer attributes have aliases that we will use for
  // display purposes.
  const layerAttributes = layer?.attributes || {}

  // Includes list
  if (layerIncludes.length > 0) {
    for (const [key, value] of Object.entries(properties)) {
      const keyLowerCase = key.toLowerCase()
      if (layerIncludesLower.includes(keyLowerCase)) {
        const index = layerIncludesLower.indexOf(keyLowerCase)

        // Use alias if provided in attributes
        const label = layerAttributes?.[key]?.alias || key

        // Temporarily store properties in an array to preserve order from includes list
        visiblePropsArray[index] = { label, value }
      }
    }

    // Convert array to object whilst maintaining order of properties in config
    visiblePropsArray.forEach(({ label, value }) => { visibleProps[label] = value })
  } else { // Excludes list
    const layerExcludes = get(layer, 'config.spatial.exclude', [])
    const state = window.store.getState()
    const templateExcludes = get(state, 'config.settings.excludeProperties', [])
    const allExcludes = layerExcludes.concat(templateExcludes).map(exclude => exclude.toLowerCase())

    if (allExcludes.length === 0) return properties
    // const labelLowerCase = get(layer, 'config.spatial.label', '').toLowerCase()

    for (const [key, value] of Object.entries(properties)) {
      if (isObject(value)) {
        continue
      }
      const keyLowerCase = key.toLowerCase()
      /* if (keyLowerCase === labelLowerCase) {
          continue // Do not add the label to these properties, use getFeatureLabel if you want it.
        } */
      if (!allExcludes.includes(keyLowerCase)) {
        // Use alias if provided in attributes
        const label = layerAttributes?.[key]?.alias || key

        visibleProps[label] = value
      }
    }
  }

  return visibleProps
}
